export default "__VITE_ASSET__tP$kJ3Ve__"